import * as React from 'react';
import { ComponentProps } from 'ui';
import styles from './log-view.scss';

export const LogView: React.FC<ComponentProps> = (props) => {

  const {
    componentId,
    className,
    children
  } = props;

  const childItems = <ul className={styles.items}>
                      {
                        React.Children.map(children, (child, i) =>
                          <li className={styles.item} key={i}>
                            {child}
                          </li>
                        )
                      }
                    </ul>;

  return (children && React.Children.count(children) !== 0 ?
    <div id={componentId} className={`${className} ${styles.logView}`}>
      {childItems}
    </div>
    : null);
};
